/**
 * EditModeButton Component
 *
 * Toggle button for entering/exiting booking edit mode.
 * Shows "REDIGER" when not editing, "AVBRYT REDIGERING" when editing.
 *
 * Ported from Vue EditButton.vue
 */

import { ActionButton } from "@/components/ui/buttons/ActionButton";
import { Icon } from "@/components/ui/display/Icon";
import classNames from "classnames";
import React from "react";
import styles from "./EditModeButton.module.css";
import type { EditModeButtonProps } from "./types";

export const EditModeButton: React.FC<EditModeButtonProps> = ({
  enabled,
  disabled = false,
  onClick,
  className,
  hide = false,
  "data-testid": testId,
}) => {
  if (!hide) {
    // Do not render the button at all

    if (enabled) {
      // In edit mode - show cancel button
      return (
        <div className={classNames(styles.container, className)}>
          <ActionButton
            label="Avbryt redigering"
            icon={<Icon name="x" size="sm" />}
            variant="danger"
            hoverVariant="danger"
            rounded
            onClick={onClick}
            data-testid={testId ?? "edit-mode-cancel-btn"}
          />
        </div>
      );
    }

    // Not in edit mode - show edit button
    return (
      <div className={classNames(styles.container, className)}>
        <ActionButton
          label="Rediger"
          icon={<Icon name="pencil" size="sm" />}
          variant="secondary"
          hoverVariant="highlight"
          rounded
          disabled={disabled}
          onClick={onClick}
          data-testid={testId ?? "edit-mode-btn"}
        />
      </div>
    );
  }
  return <></>;
};

EditModeButton.displayName = "EditModeButton";

export default EditModeButton;
